import React from "react";
import ContentHeading from "../components/ContentHeading";
import { Container } from "react-bootstrap";
// import ContentTitle from "../components/ContentTitle";
import { ourBlog } from "../data";
import icon from "../assets/images/svg/service-icon.svg";
// import OurTeam from "../components/OurTeam";
// import Testimonials from "../components/Testimonials";
import Consultation from "../components/Consultation";
import { Helmet } from "react-helmet-async";

const Blog = () => {
  return (
    <div className="">
      <Helmet>
        <title>Blog | Architecture & Design Insights by ASK & Associates</title>
        <meta
          name="description"
          content="Read the latest blogs, architecture insights, interior design trends and construction updates by ASK & Associates."
        />
        <link rel="canonical" href="https://askandassociates.com/blog" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Blog",
            name: "ASK & Associates Blog",
            url: "https://askandassociates.com/blog",
            description:
              "Architecture, interior design and construction insights by ASK & Associates.",
            publisher: {
              "@type": "Organization",
              name: "ASK & Associates",
              url: "https://askandassociates.com",
            },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "Architecture & Interior Design Blog",
            url: "https://askandassociates.com/blog",
            isPartOf: {
              "@type": "WebSite",
              name: "ASK & Associates",
              url: "https://askandassociates.com",
            },
          })}
        </script>
      </Helmet>
      <section className="section">
        <Container>
          <div className="mb-5">
            <ContentHeading heading={"Latest News"} />
            <h1 className="display-6 text-eerie-black fw-600 mb-4">
              Architecture & Interior Design Blog
            </h1>
          </div>
          <div className="row">
            {ourBlog.map((blog) => (
              <div key={blog.id} className="col-md-6 col-sm-6 mb-4">
                <article className="cursor-pointer">
                  <div className="blog-section overflow-hidden">
                    <img
                      className="blog-img img-fluid"
                      src={blog.image}
                      alt={`${blog.date} - architecture and interior design blog by ASK & Associates`}
                      loading="lazy"
                    />
                  </div>
                  <p className="mb-0 mt-3 text-deep-moss-green">{blog.date}</p>
                  <div className="d-flex justify-content-between align-items-end mt-2 mb-4">
                    <h2 className="h4 mb-0 me-2 text-eerie-black fw-600">
                      {blog.title}
                    </h2>
                    <img
                      src={icon}
                      alt="Read blog details arrow icon"
                      width="24px"
                      loading="lazy"
                    />
                  </div>
                  <div className="border-silver-chalice border-top-0"></div>
                  <p className="text-dark-charcoal mt-3 mb-0">
                    {blog.description}
                  </p>
                </article>
              </div>
            ))}
          </div>
        </Container>
      </section>
      {/* <OurTeam />
      <Testimonials /> */}
      <Consultation />
    </div>
  );
};

export default Blog;
